import { DIVISIONS_ENDPOINTS } from "../constants/api";
import { publicApiClient } from "../utils/axios.utils";

export interface Division {
    id: number;
    name: string;
    region_id: number;
    region?: {
        id: number;
        name: string;
    };
}

/**
 * Division Service
 * This service handles all API calls related to divisions.
 */
export const DivisionService = {
    getAllDivisions: async (): Promise<Division[]> => {
        const response = await publicApiClient.get(DIVISIONS_ENDPOINTS.GET_ALL);
        return response.data.data;
    },

    getDivisionsByRegion: async (regionId: number): Promise<Division[]> => {
        const response = await publicApiClient.get(
            DIVISIONS_ENDPOINTS.GET_BY_REGION(regionId)
        );
        return response.data.data;
    },
};
